import { ApiClient } from '@provider-portal/common/api';

import { createFetcher } from 'hooks/apiFetcher/createFetcher';

import { PromotionsApiFetchers } from './types';

export const createPromotionsApiFetchers = (api: ApiClient): PromotionsApiFetchers => {
  return {
    getProviderEligibilityData: createFetcher({
      name: 'promotions.getProviderEligibilityData',
      fetch: api.promotions.getProviderEligibilityData.bind(api.promotions),
    }),
    weeklyForecasts: createFetcher({
      name: 'promotions.weeklyForecasts',
      fetch: api.promotions.getWeeklyForecast.bind(api.portal),
    }),
    availableRecommendationsAndFocuses: createFetcher({
      name: 'promotions.availableRecommendationsAndFocuses',
      fetch: api.promotions.getAvailableRecommendationsAndFocuses.bind(api.promotions),
    }),
    getTestFlags: createFetcher({
      name: 'promotions.getTestFlags',
      fetch: api.promotions.getTestFlags.bind(api.promotions),
    }),
    available: createFetcher({
      name: 'promotions.available',
      fetch: api.promotions.getProviderAvailablePromotions.bind(api.portal),
    }),
    availableSelfServiceOptions: createFetcher({
      name: 'promotions.availableSelfServiceOptions',
      fetch: api.promotions.getAvailablePromotionsOptionsTree.bind(api.portal),
    }),
    list: createFetcher({
      name: 'promotions.list',
      fetch: api.promotions.getAssignedPromotions.bind(api.portal),
    }),
    details: createFetcher({
      name: 'promotions.details',
      fetch: api.promotions.getPromotionDetails.bind(api.portal),
    }),
    singIn: createFetcher({
      name: 'promotions.signIn',
      fetch: api.promotions.signUpPromotion.bind(api.portal),
    }),
    singOut: createFetcher({
      name: 'promotions.signOut',
      fetch: api.promotions.cancelPromotionRegistration.bind(api.portal),
    }),
    storeAnalyticsEvent: createFetcher({
      name: 'promotions.storeAnalyticsEvent',
      fetch: api.promotions.storeAnalyticsEvent.bind(api.promotions),
    }),
    fetchPromotionsPermissions: createFetcher({
      name: 'promotions.fetchPromotionsPermissions',
      fetch: api.promotions.getPromotionsPermissions.bind(api.promotions),
    }),
    getMenuItemsForProviderActiveMenu: createFetcher({
      name: 'promotions.getMenuItemsForProviderActiveMenu',
      fetch: api.portal.getMenuItemsForProviderActiveMenu.bind(api.portal),
    }),
    fetchSelfServiceCampaignMeta: createFetcher({
      name: 'promotions.fetchSelfServiceCampaignMeta',
      fetch: api.promotions.getSelfServiceCampaignMeta.bind(api.promotions),
    }),
    updateMenuItemsForPromotion: createFetcher({
      name: 'promotions.updateMenuItemsForPromotion',
      fetch: api.promotions.updateMenuItemsForPromotion.bind(api.promotions),
    }),
    getCityExclusionTags: createFetcher({
      name: 'promotions.getCityExclusionTags',
      fetch: api.promotions.getCityExclusionTags.bind(api.promotions),
    }),
  };
};
